export function MobileSuccessPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-ct-bg p-4 overflow-hidden">
      <div className="pointer-events-none fixed inset-0 overflow-hidden -z-10" aria-hidden="true">
        <div className="absolute -top-[20%] -right-[10%] h-[500px] w-[500px] rounded-full bg-gradient-to-br from-ct-primary/10 to-ct-secondary/10 blur-[150px]" />
        <div className="absolute -bottom-[15%] -left-[10%] h-[300px] w-[300px] rounded-full bg-gradient-to-br from-ct-secondary/8 to-ct-primary/8 blur-[100px]" />
      </div>

      <div className="w-full max-w-sm rounded-xl bg-ct-surface border border-ct-border shadow-ct-sm p-8 text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-600 shadow-ct-lg">
          <svg className="h-8 w-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="mb-2 text-2xl font-extrabold tracking-tight text-ct-text">
          Вы успешно авторизованы
        </h1>
        <p className="text-sm text-ct-text-muted">
          Теперь вы можете сканировать QR-коды для регистрации участников
        </p>
      </div>
    </div>
  );
}
